const getChiModules = (message, realDevice, ioc) => {
    let gameRandom = ioc.run(
        "3r/chi/factories/random",
        {
            message: message
        }
    )

    let throws = ioc.run(
        "3r/chi/factories/throws",
        {
            message: message
        }
    )

    let gameNavigation = {
        next : function () {
            return Promise.resolve(true)
        }
    }

    let gameDevice = ioc.run(
        "3r/chi/factories/device",
        {
            gameNavigation: gameNavigation,
            message: message
        }
    )

    return {
        device : gameDevice,
        navigation : gameNavigation,
        random : gameRandom, 
        throws: throws,
        realDevice: realDevice,
        ioc: ioc
    }     
}

const ChiModuleLoader = {
    getChiModules: getChiModules
}

export default ChiModuleLoader;